import { useEffect } from "react";
import { useLang, localize } from "@/lib/i18n";

const setLink = (rel, hreflang, href) => {
  const sel = hreflang ? `link[rel="${rel}"][hreflang="${hreflang}"]` : `link[rel="${rel}"]`;
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("link");
    el.rel = rel;
    if (hreflang) el.hreflang = hreflang;
    document.head.appendChild(el);
  }
  el.href = href;
};

export function usePageMeta({ title, description }) {
  const { lang, basePath } = useLang();
  useEffect(() => {
    document.title = title;
    document.documentElement.lang = lang;
    const setMeta = (attr, key, content) => {
      let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.content = content;
    };
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:site_name", "TubeOptimizer LLC");
    setMeta("property", "og:locale", lang === "en" ? "en_US" : "fr_FR");
    const origin = window.location.origin;
    setMeta("property", "og:url", origin + localize(basePath, lang));
    setLink("alternate", "fr", origin + localize(basePath, "fr"));
    setLink("alternate", "en", origin + localize(basePath, "en"));
    setLink("alternate", "x-default", origin + localize(basePath, "fr"));
    setLink("canonical", null, origin + localize(basePath, lang));
  }, [title, description, lang, basePath]);
}
